import parseHTML from './_parseHtml';

const triggerWishlistAlert = function (messages, image, wishlistLink) {
    const template = `
        <div is='m-wishlist-alert'>
            <img src="${image.url}" alt="${image.alt}" />
            <div class="msg t-body-bold">${messages.msg}</div>
            <a href="${wishlistLink}" class="t-body-bold">${messages.see}</a>
        </div>`;
    const wishlistElem = parseHTML(template);
    document.body.appendChild(wishlistElem);
};

const getWishlistArray = function () {
    var wishlistContent = document.querySelector('#wishlistPids');
    return wishlistContent ? JSON.parse(wishlistContent.value) : [];
};

const activateNavigationHeartButton = function (pids) {
    let wishlistContent = pids;
    if (!wishlistContent) {
        wishlistContent = getWishlistArray();
    }

    const wishlistLinks = document.querySelectorAll('.wishlist-link');
    if (wishlistLinks.length > 0) {
        for (let i = 0; i < wishlistLinks.length; i++) {
            wishlistLinks[i].classList.toggle('active', wishlistContent.length);
        }
    }
};

const updateWishlistPids = function (wishlistPids) {
    if (wishlistPids) {
        var wishlistContent = document.querySelector('#wishlistPids');
        if (wishlistContent) wishlistContent.value = wishlistPids;
    }
    activateNavigationHeartButton();
};

const addOrRemoveToWishlist = function (wishListUrl, wishlistLink, formData, imageUrl, imageAlt, svgIcon) {
    // Ajax call to Wishlist API
    fetch(wishListUrl, {
        method: 'POST',
        body: formData
    }).then((response) => response.json()).then((responseData) => {
        var messages = { msg: '', see: '' };
        var image = { url: imageUrl, alt: imageAlt };
        svgIcon.parentNode.classList.toggle('active');
        if (responseData.gtmData) {
            document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                detail: {
                    data: responseData.gtmData,
                    pageType: true
                }
            }));
        }
        if (responseData.msg) { messages.msg = responseData.msg; }
        if (responseData.msg2) { messages.see = responseData.msg2; }
        if (responseData.wishlistPids) { updateWishlistPids(responseData.wishlistPids); }
        triggerWishlistAlert(messages, image, wishlistLink);
    });
};

const activateWishlistHeartButtons = function () {
    var wishlistArray = getWishlistArray();
    if (wishlistArray && wishlistArray.length > 0) {
        for (var i = 0; i < wishlistArray.length; i++) {
            var testPidInPage = document.querySelectorAll('[data-pid="' + wishlistArray[i] + '"]');

            if (testPidInPage) {
                // Same PID can occur multiple times in the same page (ex. search sidebar + plp + dy recommendations)
                for (var pidOccurence of testPidInPage) {
                    var wlBtn = pidOccurence.querySelector('.btn-wishlist');
                    if (wlBtn) wlBtn.classList.add('active');
                }
            }
        }
    }
};

const activatePdpWishlistButton = function (btnElement) {
    var wishlistArray = getWishlistArray();
    var oPdpGrid = document.querySelector('[is="o-pdp-grid"]');
    const vgId = oPdpGrid.dataset.variationGroupId;

    if (wishlistArray.includes(vgId)) {
        btnElement.classList.add('active');
    }
};

document.addEventListener('DOMContentLoaded', function () {
    activateNavigationHeartButton();
});

export default {
    triggerWishlistAlert: triggerWishlistAlert,
    addOrRemoveToWishlist: addOrRemoveToWishlist,
    activateWishlistHeartButtons: activateWishlistHeartButtons,
    getWishlistArray: getWishlistArray,
    activatePdpWishlistButton: activatePdpWishlistButton
};
